import { render } from "./ForgetPassword.vue?vue&type=template&id=444c406a&ts=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__